module.exports = __webpack_public_path__ + "h5/img/1.fe754ecb.jpg";